<template>
  <div class="my-3">
    <p class="mb-0 font-weight-bold">RegAlytics Alert ID</p>
    <input :value="statusDetails" class="form-control form-control-sm" type="text"
           @change="(event) => updateStatus(event.target.value)">
  </div>
</template>

<script>
import {addOrUpdateParameter} from "@/helpers/urlParamsHelper";

export default {
  name: "RegAlyticsAlertId",

  computed: {
    statusDetails: function () {
      return this.$store.getters["search/getRegAlyticsAlertId"];
    }
  },

  methods: {
    updateStatus(value) {
      this.$store.dispatch('search/updateRegAlyticsAlertId', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("regAlyticsAlertID", encodedParams);
    }
  }
}
</script>